module.exports = __webpack_public_path__ + "img/26.3117193b.png";